import { createWebHashHistory, createRouter } from "vue-router";
import StartView from "@/views/StartView.vue";
import StepView from "@/views/StepView.vue";

const routes = [
  {
    path: "/",
    name: "Start",
    component: StartView,
  },
  {
    path: '/step/:id',
    name: 'Step',
    component: StepView,
  }
  
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});


router.beforeEach((/* to, from */) => {
  
});

export default router;